import type { TariffServiceType } from '../modal';

export const tariffKeys = {
  tariff: ['tariff'],
  tariffs: (service_type?: TariffServiceType) => ['tariffs', service_type],
  projectTariff: (slug: string) => [...tariffKeys.tariff, slug],
  quota: (slug: string) => [...tariffKeys.tariff, 'quota', slug],
};
